$(function () {
   'use strict';

   initialize();

    function initialize() {
        if ($('.read-more').length === 0) return;

        if (isHuffpostEdition(document.referrer)) {
            showEntry();
        } else {
            showContinue();
        }
    }

    function showEntry() {
        $('.post-hidden').css({
            'height': 'auto',
            'overflow': 'auto',
            'margin-bottom': 0
        });

        // Hide the button if shown
        $('.read-more').hide();
        $('.comment-button.js-comment-button').removeClass('desktop-only'); // see social_share.js
        $(document).trigger('render:mw-paragraph-ads');
    }

    function showContinue() {
        // Read More Link on mobile B pages
        $('.read-more-link').on('click', function() {
            MW.events.publish('read_more');
            showEntry();
        });
    }

    function isHuffpostEdition(url) {
        var editions = $('.read-more').data('editions').split(' ');

        if (url) {
            for (var i = 0, len = editions.length; i < len; i++) {
                if (url.indexOf(editions[i]) >= 0) {
                    return true;
                }
            }
        }

        return false;
    }
});
